import SEO from '../components/common/SEO';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="policy-page">
      <SEO
        title="Privacy Policy & Terms"
        description="Read the privacy policy, warranty, and return terms for Essentick. We are committed to transparency and protecting your information."
        keywords="privacy policy, warranty, returns, terms and conditions, Essentick"
      />
      <header className="policy-header">
        <h1>Privacy Policy, Warranty &amp; Return Policy</h1>
        <p className="policy-updated">Last Updated: 2026/02/10</p>
      </header>

      <section className="policy-section">
        <h2>1. Introduction</h2>
        <p>
          Welcome to Essentick. We value your trust and are committed to protecting your personal
          information. This policy explains how we collect, use, and protect customer data, along
          with our warranty, return, and liability terms.
        </p>
        <p>By purchasing from us, you agree to the terms outlined below.</p>
      </section>

      <section className="policy-section">
        <h2>2. Information We Collect</h2>
        <p>We may collect the following information:</p>
        <ul>
          <li>Customer name</li>
          <li>Phone number</li>
          <li>Delivery address</li>
          <li>Email address (if provided)</li>
          <li>Order details and purchase history</li>
        </ul>
        <p className="policy-highlight">
          We <strong>do not store</strong> card, wallet, or banking passwords.
        </p>
      </section>

      <section className="policy-section">
        <h2>3. How We Use Your Information</h2>
        <p>Your information is used strictly for:</p>
        <ul>
          <li>Order processing and delivery</li>
          <li>Customer support</li>
          <li>Order updates and confirmations</li>
          <li>Legal or regulatory requirements (if needed)</li>
        </ul>
        <p className="policy-highlight">
          We <strong>do not sell, rent, or share</strong> your personal information with third
          parties for marketing.
        </p>
      </section>

      <section className="policy-section">
        <h2>4. Data Protection &amp; Security</h2>
        <p>
          We take reasonable security measures to protect customer data. However, no online platform
          is 100% secure, and we cannot guarantee absolute protection against cyber threats.
        </p>
      </section>

      <section className="policy-section">
        <h2>5. Warranty Policy (Very Important)</h2>
        <p>
          <strong>We provide warranty ONLY on the watch machine (movement).</strong>
        </p>
        <p>
          <strong>Warranty is NOT provided for:</strong>
        </p>
        <ul>
          <li>Battery</li>
          <li>Strap or bracelet</li>
          <li>Glass</li>
          <li>Dial</li>
          <li>Buttons / crown</li>
          <li>Color fading</li>
          <li>Rusting</li>
          <li>Water damage</li>
          <li>Physical or accidental damage</li>
        </ul>
        <p>Warranty is applicable only if:</p>
        <ul>
          <li>The watch has a genuine machine issue</li>
          <li>There is no sign of physical damage, water entry, or tampering</li>
        </ul>
        <p>Warranty duration (if applicable) will be clearly mentioned at the time of sale.</p>
      </section>

      <section className="policy-section">
        <h2>6. Return &amp; Exchange Policy</h2>
        <p>
          <strong>No return or exchange will be provided in the following cases:</strong>
        </p>
        <ul>
          <li>Color fading</li>
          <li>Physical damage</li>
          <li>Scratches or broken parts</li>
          <li>Battery issues</li>
          <li>Change of mind after purchase</li>
        </ul>
        <p>Return, repair or exchange is considered <strong>only if</strong>:</p>
        <ul>
          <li>The product delivered is <strong>wrong or defective</strong></li>
          <li>The issue is reported within <strong>24 hours of delivery</strong></li>
          <li>Unboxing video is provided as proof</li>
          <li>
            If the watch is <strong>water resistant</strong> and water enters within the warranty
            period under normal usage, the product will be <strong>repaired or replaced</strong>.
          </li>
        </ul>
        <p>Without proper proof, claims may be rejected.</p>
      </section>

      <section className="policy-section">
        <h2>7. Product Disclaimer</h2>
        <ul>
          <li>
            Product images are for reference only; minor color or design variations may occur due to
            lighting or screen differences.
          </li>
          <li>Watches should be handled carefully. Improper use may reduce lifespan.</li>
          <li>Water resistance does <strong>not</strong> mean waterproof unless explicitly stated.</li>
        </ul>
      </section>

      <section className="policy-section">
        <h2>8. Shipping &amp; Delivery</h2>
        <ul>
          <li>Delivery time may vary based on location and courier service.</li>
          <li>
            We are not responsible for delays caused by couriers, strikes, weather, or unforeseen
            events.
          </li>
        </ul>
      </section>

      <section className="policy-section">
        <h2>9. Limitation of Liability</h2>
        <p>Essentick shall not be liable for:</p>
        <ul>
          <li>Indirect or consequential losses</li>
          <li>Misuse or negligence by the customer</li>
          <li>Damage caused after delivery</li>
        </ul>
        <p>
          Maximum liability is limited to the <strong>product purchase price only</strong>.
        </p>
      </section>

      <section className="policy-section">
        <h2>10. Policy Updates</h2>
        <p>
          We reserve the right to update or modify this policy at any time without prior notice.
          Updated policies will be effective immediately once posted.
        </p>
      </section>

      <section className="policy-section">
        <h2>11. Contact Information</h2>
        <p>For questions or concerns, contact us at:</p>
        <ul>
          <li>
            Phone/WhatsApp: <a href="tel:9828917528">9828917528</a>
          </li>
          <li>
            Email: <a href="mailto:essentique100@gmail.com">essentique100@gmail.com</a>
          </li>
          <li>Location: Nepal</li>
        </ul>
      </section>
    </div>
  );
};

export default PrivacyPolicy;

